module.exports = __webpack_public_path__ + "img/purchases.6ee988d.svg";